import React from 'react';
import { Paper, Typography } from '@mui/material';
import { getAnalysisText } from './aiReportUtils';
import { fallbackStyles } from './styles';

export default function FlowAnalysisFallback({ data }) {
  const failedAttributes = Array.isArray(data?.failed_attributes) ? data.failed_attributes : [];

  return (
    <>
      {data?.total_failures > 0 && failedAttributes.length > 0 && (
        <>
          <Typography variant="h6" sx={fallbackStyles.heading}>
            Failed Attributes
          </Typography>

          {failedAttributes.map((item, index) => (
            <Paper
              key={`${item.event || 'event'}-${index}`}
              sx={fallbackStyles.failedAttributeCard}
            >
              <Typography>
                <strong>Event:</strong> {item.event}
              </Typography>
              <Typography>
                <strong>Failure Type:</strong> {item.failure_type}
              </Typography>
              <Typography>
                <strong>Variable:</strong> {item.variable_name}
              </Typography>
              <Typography>
                <strong>Expected:</strong> {item.expected_value}
              </Typography>
              <Typography>
                <strong>mParticle:</strong> {item.mparticle_actual}
              </Typography>
              <Typography>
                <strong>GMA:</strong> {item.gma_actual || 'N/A'}
              </Typography>
              <Typography>
                <strong>Field Type:</strong> {item.field_type}
              </Typography>
              <Typography>
                <strong>Source:</strong> {item.failing_source}
              </Typography>
            </Paper>
          ))}
        </>
      )}

      <Typography variant="h6" sx={fallbackStyles.analysisHeading}>
        AI Analysis
      </Typography>

      <Paper sx={fallbackStyles.flowAnalysisPaper}>
        <Typography sx={fallbackStyles.analysisText}>{getAnalysisText(data)}</Typography>
      </Paper>
    </>
  );
}
